<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <div class="mb-3">
      <div class="row">
        <div class="col-11"><h4>Avisos</h4></div>
        <div class="col-1">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true" aria-label="Abrir ayuda de avisos">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Avisos">
      <AyudaAviso />
    </Modal>

    <hr>

    <DataTable
      :data="avisos"
      :columns="columnas"
      idField="idAviso"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      mensajeVacio="No hay avisos registrados."
      @refresh="getDataTodos()"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idAviso)"
      @delete="row => deleteAviso(row.idAviso)"
    >
      <!-- Búsqueda por nombre en slot acciones-extra -->
      <template #acciones-extra>
        <div class="col-auto d-flex gap-2">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar por nombre..."
            style="width:260px; text-transform:uppercase"
            @keyup.enter="buscar"
          />
          <button class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
            @click="buscar" title="Buscar">
            <span class="material-symbols-outlined" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Celda: Fecha Reg -->
      <template #cell-fechaReg="{ row }">
        {{ getFormattedDate(row.fechaReg) }}
      </template>

      <!-- Celda: Fecha Envío -->
      <template #cell-fechaEnvio="{ row }">
        {{ getFormattedDate(row.fechaEnvio) }}
      </template>

      <!-- Celda: Estado -->
      <template #cell-estadoAviso="{ row }">
        <span :class="row.estadoAviso === 'ENVIADO' ? 'badge bg-success' : 'badge bg-warning text-dark'">
          {{ row.estadoAviso }}
        </span>
      </template>
    </DataTable>

    <!-- Modal Aviso -->
    <div class="modal fade" id="ventanaModalAviso" tabindex="-1"
         aria-labelledby="modalAvisoLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalAvisoLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">

              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Id. Aviso</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoAviso.idAviso" disabled>
                  </div>
                  <div class="col-2"><label class="col-form-label">Fecha Reg.</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoAviso.fechaReg" disabled>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Título</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoAviso.titulo"
                      style="text-transform:uppercase">
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Texto</label></div>
                  <div class="col-10">
                    <textarea class="form-control" v-model="datoAviso.texto"
                      style="text-transform:uppercase" rows="4"></textarea>
                  </div>
                </div>
              </div>

              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="col-form-label">Estado</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoAviso.estadoAviso"
                      style="text-transform:uppercase">
                  </div>
                  <div class="col-2"><label class="col-form-label">Fecha Envío</label></div>
                  <div class="col-4">
                    <input type="date" class="form-control" v-model="datoAviso.fechaEnvio">
                  </div>
                </div>
              </div>

            </div>
          </form>

          <div class="modal-footer">
            <button v-if="btnCrear" type="button"
              class="btn btn-success d-flex align-items-center gap-1"
              @click="guardarAviso">
              <span class="material-symbols-outlined">save</span> Guardar
            </button>
            <button v-if="btnEditar" type="button"
              class="btn btn-success d-flex align-items-center gap-1"
              @click="guardarEditAviso">
              <span class="material-symbols-outlined">update</span> Actualizar
            </button>
            <button v-if="btnEditar" type="button"
              class="btn btn-primary d-flex align-items-center gap-1"
              @click="guardarEditAvisoEstado">
              <span class="material-symbols-outlined">send</span> Listo
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout     from '@/components/Layout.vue'
import Footer     from '@/components/Footer.vue'
import AyudaAviso from '@/views/ayuda/AyudaAviso.vue'
import DataTable  from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'
import { Modal }  from 'bootstrap'
import swal       from 'sweetalert'

export default {
  components: { Layout, Footer, AyudaAviso, DataTable },
  data() {
    return {
      avisos:        [],
      datoAviso:     {},
      nombreBusqueda:'',
      titulo:        '',
      btnCrear:      false,
      btnEditar:     false,
      modalWindow:   true,
      showModalHelp: false,
      columnas: [
        { field: 'titulo',       label: 'Título' },
        { field: 'texto',        label: 'Texto' },
        { field: 'estadoAviso',  label: 'Estado',      filterType: 'select', filterOptions: [] },
        { field: 'fechaReg',     label: 'Fecha Reg.' },
        { field: 'fechaEnvio',   label: 'Fecha Envío' },
      ],
    }
  },
  computed: {
    opcionesEstado() {
      const set = new Set(this.avisos.map(a => a.estadoAviso).filter(Boolean))
      return [...set].sort()
    },
  },
  watch: {
    opcionesEstado(vals) {
      const col = this.columnas.find(c => c.field === 'estadoAviso')
      if (col) col.filterOptions = vals
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.getDataTodos()
  },
  methods: {
    getFormattedDate(date) { return dateFormat.getFormattedDate(date) },

    getModalInstance() {
      const el = document.getElementById('ventanaModalAviso')
      return el ? Modal.getInstance(el) ?? new Modal(el) : null
    },

    // ── Carga ─────────────────────────────────────────────────────────────
    getDataTodos() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get(`/vwavisos/idempresa/${idEmpresa}`)
        .then(r => { this.avisos = r.data.reverse() })
        .catch(err => console.error('Error al obtener avisos:', err))
    },
    buscar() {
      if (!this.nombreBusqueda.trim()) { this.getDataTodos(); return }
      api.get(`/vwavisos/nombre/${this.nombreBusqueda}`)
        .then(r => { this.avisos = r.data.reverse() })
        .catch(err => console.error('Error en búsqueda:', err))
    },

    // ── Validación ────────────────────────────────────────────────────────
    validarFormLocal() {
      return validarForm(this.datoAviso, ['texto'], ['texto'])
    },

    // ── CRUD ──────────────────────────────────────────────────────────────
    async guardarAviso() {
      if (this.validarFormLocal() !== 1) return
      try {
        this.datoAviso.idEmpresa = window.sessionStorage.getItem('idEmpresa')
        await api.post('/avisos', this.datoAviso)
        this.getModalInstance()?.hide()
        swal('Correcto!', 'Aviso creado exitosamente!', 'success')
        this.getDataTodos()
      } catch { swal('Error!', 'Inténtelo de nuevo!', 'error') }
    },
    async guardarEditAviso() {
      if (this.validarFormLocal() !== 1) return
      try {
        await api.post('/avisos', this.datoAviso)
        this.getModalInstance()?.hide()
        swal('Correcto!', 'Aviso actualizado exitosamente!', 'success')
        this.getDataTodos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },
    async guardarEditAvisoEstado() {
      if (this.validarFormLocal() !== 1) return
      this.datoAviso.estadoAviso = 'PENDIENTE'
      try {
        await api.post('/avisos', this.datoAviso)
        this.getModalInstance()?.hide()
        swal('Correcto!', 'Aviso enviado exitosamente!', 'success')
        this.getDataTodos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },
    abrirModalCrear() {
      this.datoAviso = {}
      this.titulo    = 'Registrar Aviso'
      this.btnCrear  = true
      this.btnEditar = false
      this.$nextTick(() => this.getModalInstance()?.show())
    },
    abrirModalEditar(idAviso) {
      this.titulo    = 'Editar Aviso'
      this.btnCrear  = false
      this.btnEditar = true
      if (idAviso) {
        api.get(`/vwavisos/${idAviso}`).then(r => { this.datoAviso = r.data })
      }
      this.$nextTick(() => this.getModalInstance()?.show())
    },
    async deleteAviso(idAviso) {
      try {
        await api.delete(`/avisos/${idAviso}`)
        this.getDataTodos()
      } catch { swal('Error!', 'No se pudo eliminar.', 'error') }
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>